export const typeList = [
  {
    name: '软件基础模块',
    code: '1',
    imgSrc: '#icon-back-ruanjianjichumokuai',
    backColor: '#59C66E',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '费用到期时间',
        value: 'expire_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      },
      {
        title: '剩余可用天数',
        value: 'remainDays'
      },
      {
        title: '购买用户数',
        value: 'total_user'
      },
      {
        title: '在线用户数',
        value: 'online_user'
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      }
    ]
  },
  {
    name: '企查查基础数据',
    code: '3',
    imgSrc: '#icon-back-qichachajichushuju',
    backColor: '#F79340',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      // {
      //   title: "费用到期时间",
      //   value: "expire_time"
      // },
      {
        title: '累计充值(次)',
        value: 'total_recharge'
      },
      {
        title: '已使用(次)',
        value: 'total_times'
      },
      {
        title: '剩余可用(次)',
        valueMax: 'total_recharge',
        valueMin: 'total_times',
        custom: 2
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '账单记录',
        icon: 'el-icon-edit',
        funs: 'billRecord'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      }
    ]
  },
  {
    name: '进项发票推送',
    code: '5',
    imgSrc: '#icon-back-jinxiangfapiaotuisong',
    backColor: '#2C3B66',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '费用到期时间',
        value: 'expire_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      },
      {
        title: '剩余可用天数',
        value: 'remainDays'
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      },
      {
        name: '维护税号',
        icon: 'el-icon-setting',
        funs: 'showtaxNo',
        isTenant: 2
      }
    ]
  },
  {
    name: '凭证推送',
    code: '6',
    imgSrc: '#icon-back-pingzhengtuisong',
    backColor: '#63808f',
    isShowRed: false,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      },
      // {
      //   title: "目前状态",
      //   value: "pay_status",
      //   custom: 1
      // },
      {
        title: '系统类型',
        value: 'tax_no'
      },
      {
        title: '对接地址',
        value: 'url',
        isShowBtn: false
      },
      {
        title: '应用id',
        value: 'finance_client_id',
        isShowBtn: true
      },
      {
        title: '应用秘钥',
        value: 'finance_client_secret',
        isShowBtn: true
      }
    ],
    toolsList: [
      {
        name: '凭证配置',
        icon: 'el-icon-setting',
        funs: 'showNcConfig',
        isTenant: 2
      },
      {
        name: '初始化配置',
        icon: 'el-icon-setting',
        funs: 'showInitConfig',
        isTenant: 3
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      }
    ]
  },
  {
    name: '支付宝接口',
    code: '7',
    imgSrc: '#icon-back-back-zhifubaojiekou',
    backColor: '#377CFF',
    isShowRed: false,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      },
      // {
      //   title: "目前状态",
      //   value: "pay_status",
      //   custom: 1
      // },
      {
        title: '绑定支付宝账号',
        value: 'alipay_account'
      },
      {
        title: '账户名称',
        value: 'alipay_name'
      }
    ],
    toolsList: [
      {
        name: '绑定账号',
        icon: 'el-icon-s-opportunity',
        funs: 'showZfbConfig',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      }
    ]
  },
  {
    name: 'OCR',
    code: '8',
    imgSrc: '#icon-back-OCR',
    backColor: 'rgba(255, 136, 8, 100)',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '累计充值(次)',
        value: 'total_recharge'
      },
      {
        title: '已使用(次)',
        value: 'total_times'
      },
      {
        title: '剩余可用(次)',
        valueMax: 'total_recharge',
        valueMin: 'total_times',
        custom: 2
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '账单记录',
        icon: 'el-icon-edit',
        funs: 'billRecord'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      }
    ]
  },
  {
    name: '银企直联',
    code: '9',
    imgSrc: '#icon-back-yinqizhilian',
    backColor: 'rgba(35, 179, 226, 100)',
    isShowRed: false,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      },
      // {
      //   title: "目前状态",
      //   value: "pay_status",
      //   custom: 1
      // },
      {
        title: '企业号',
        value: 'tax_no'
      },
      {
        title: '对接地址',
        value: 'url'
      }
    ],
    toolsList: [
      {
        name: '初始化配置',
        icon: 'el-icon-setting',
        funs: 'showInitConfigCbs',
        isTenant: 3
      },
      {
        name: '银企直联配置',
        icon: 'el-icon-position',
        funs: 'showCbsConfig',
        isTenant: 2
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      }
    ]
  },
  {
    name: 'E签宝',
    code: '10',
    imgSrc: '#icon-back-Eqianbao',
    backColor: 'rgba(35, 179, 226, 100)',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '累计充值(次)',
        value: 'total_recharge'
      },
      {
        title: '已使用(次)',
        value: 'total_times'
      },
      {
        title: '剩余可用(次)',
        valueMax: 'total_recharge',
        valueMin: 'total_times',
        custom: 2
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '账单记录',
        icon: 'el-icon-edit',
        funs: 'billRecord'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      },
      {
        name: '默认签署人',
        icon: 'el-icon-setting',
        funs: 'showQSRConfig',
        isTenant: 2
      }
    ]
  },
  {
    name: '美团企业版',
    code: '11',
    imgSrc: '#icon-back-meituanqiyeban',
    backColor: 'rgba(255, 196, 0, 100)',
    isShowRed: false,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      }
      // {
      //   title: "系统类型",
      //   value: "system_type"
      // }
      // {
      //   title: "目前状态",
      //   value: "pay_status",
      //   custom: 1
      // }
    ],
    toolsList: [
      {
        name: '参数设置',
        icon: 'el-icon-edit',
        funs: 'cspz'
      },
      {
        name: '同步信息',
        icon: 'el-icon-setting',
        funs: 'synchronization'
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      }
      // {
      //   name: "用车规则维护",
      //   icon: "el-icon-setting",
      //   funs: "ycgzwh"
      // },
    ]
  },
  {
    name: '新筑课堂',
    code: '12',
    imgSrc: '#icon-back-xinzhuketang',
    backColor: '#59C66E',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '费用到期时间',
        value: 'expire_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      },
      {
        title: '剩余可用天数',
        value: 'remainDays'
      },
      {
        title: '购买用户数',
        value: 'total_user'
      },
      {
        title: '剩余可增用户',
        valueMax: 'total_user',
        valueMin: 'userCount',
        custom: 2
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '注册账号',
        icon: 'el-icon-position',
        funs: 'showXzConfigDialog',
        isTenant: 2
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      },
      {
        name: '组织同步',
        icon: 'el-icon-position',
        funs: 'xzSyncOrg',
        isTenant: 1
      },
      {
        name: ' 岗位同步',
        icon: 'el-icon-s-opportunity',
        funs: 'xzSyncPos',
        isTenant: 1
      },
      {
        name: '职位同步',
        icon: 'el-icon-setting',
        funs: 'xzSyncJob',
        isTenant: 1
      },
      {
        name: '员工同步',
        icon: 'el-icon-setting',
        funs: 'showXzSyncUser',
        isTenant: 1
      }
    ]
  },
  {
    name: '钉钉考勤接口',
    code: '13',
    imgSrc: '#icon-back-dingdingkaoqinjiekou',
    backColor: '#2C3B66',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '累计充值(项目数)',
        value: 'total_recharge'
      },
      {
        title: '已使用(项目数)',
        value: 'total_times'
      },
      {
        title: '剩余可用(项目数)',
        valueMax: 'total_recharge',
        valueMin: 'total_times',
        custom: 2
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      },
      {
        name: '账单记录',
        icon: 'el-icon-edit',
        funs: 'billRecord',
        isTenant: 2
      },
      {
        name: '参数配置',
        icon: 'el-icon-setting',
        funs: 'showDDMaintain',
        isTenant: 1
      }
    ]
  },
  {
    name: '百望进项发票推送',
    code: '14',
    imgSrc: '#icon-back-jinxiangfapiaotuisong',
    backColor: '#2C3B66',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '费用到期时间',
        value: 'expire_time'
      },
      {
        title: '使用天数',
        value: 'totalUseDays'
      },
      {
        title: '剩余可用天数',
        value: 'remainDays'
      }
      //{
      // title: "目前状态",
      // value: "pay_status",
      //custom: 1
      //   }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      },
      {
        name: '维护税号',
        icon: 'el-icon-setting',
        funs: 'showBwTaxNo',
        isTenant: 2
      }
    ]
  },
  {
    name: '天眼查',
    code: '15',
    imgSrc: '#icon-back-qichachajichushuju',
    backColor: '#F79340',
    isShowRed: true,
    menuList: [
      {
        title: '开通时间',
        value: 'initial_open_time'
      },
      {
        title: '累计充值(次)',
        value: 'total_recharge'
      },
      {
        title: '已使用(次)',
        value: 'total_times'
      },
      {
        title: '剩余可用(次)',
        valueMax: 'total_recharge',
        valueMin: 'total_times',
        custom: 2
      }
    ],
    toolsList: [
      {
        name: '立即充值',
        icon: 'el-icon-position',
        funs: 'immediateIn'
      },
      {
        name: '账单记录',
        icon: 'el-icon-edit',
        funs: 'billRecord'
      },
      {
        name: '提醒设置',
        icon: 'el-icon-s-opportunity',
        funs: 'showReminder',
        isTenant: 1
      },
      {
        name: '维护',
        icon: 'el-icon-setting',
        funs: 'showMaintain',
        isTenant: 2
      },
      {
        name: '参数设置',
        icon: 'el-icon-edit',
        funs: 'tianyanchaPz'
      }
    ]
  }
]
export const cellStatusList = [
  {
    name: '余额不足',
    code: 0
  },
  {
    name: '正常',
    code: 1
  },
  {
    name: '欠费',
    code: 2
  }
]

export function handleType(config) {
  if (config == 'k3') {
    typeList.forEach((item) => {
      if (item.code == 6) {
        item.menuList = [
          {
            title: '开通时间',
            value: 'initial_open_time'
          },
          {
            title: '使用天数',
            value: 'totalUseDays'
          },
          {
            title: '系统类型',
            value: 'tax_no'
          },
          {
            title: '对接地址',
            value: 'url',
            isShowBtn: true
          },
          {
            title: '应用id',
            value: 'finance_client_id',
            isShowBtn: false
          },
          {
            title: '应用秘钥',
            value: 'finance_client_secret',
            isShowBtn: false
          }
        ]
      }
    })
  } else {
    typeList.forEach((item) => {
      if (item.code == 6) {
        item.menuList = [
          {
            title: '开通时间',
            value: 'initial_open_time'
          },
          {
            title: '使用天数',
            value: 'totalUseDays'
          },
          {
            title: '系统类型',
            value: 'tax_no'
          },
          {
            title: '对接地址',
            value: 'url',
            isShowBtn: false
          },
          {
            title: '应用id',
            value: 'finance_client_id',
            isShowBtn: true
          },
          {
            title: '应用秘钥',
            value: 'finance_client_secret',
            isShowBtn: true
          }
        ]
      }
    })
  }
}
